import type { TestShackReportInspection } from "@/pages/products/test-shack/models/TestShackReport";
import { TestShackReportSectionRevList as SharedSectionRevList } from "@/pages/products/test-shack/shared/components/report/TestShackReportSectionRevList";
import type { TestShackReportSectionRev } from "../models/TestShackReportSectionRev";
import { testShackReportExcelParams } from "@/pages/products/test-shack/utils/reportExcelExport";
import { formatReading, formatSpecMeasurement } from "../utils/format";
import { M1TestShackReportSectionRevCard } from "./M1TestShackReportSectionRevCard";

interface TestShackReportSectionRevListProps {
	sectionRevs: TestShackReportSectionRev[];
	inspections: TestShackReportInspection[];
	isLoading: boolean;
	problemsOnly: boolean;
	showMinTargetMax: boolean;
	onProblemsOnlyChange: (problemsOnly: boolean) => void;
	onShowMinTargetMaxChange: (showMinTargetMax: boolean) => void;
	onViewImages: (inspection: TestShackReportInspection) => void;
	onError: (error: Error) => void;
}

export const M1TestShackReportSectionRevList = ({
	sectionRevs,
	inspections,
	onViewImages,
	...props
}: TestShackReportSectionRevListProps) => (
	<SharedSectionRevList
		{...props}
		sectionRevs={sectionRevs}
		inspectionCount={inspections.length}
		getExportParams={() =>
			testShackReportExcelParams(sectionRevs, props.showMinTargetMax, {
				header: (column) => column.displayName,
				spec: formatSpecMeasurement,
				reading: formatReading,
			})
		}
		renderSectionRev={({ sectionRev, isCollapsed, onToggle }) => (
			<M1TestShackReportSectionRevCard
				sectionRev={sectionRev}
				isCollapsed={isCollapsed}
				showMinTargetMax={props.showMinTargetMax}
				onToggle={onToggle}
				onError={props.onError}
				onViewImages={onViewImages}
			/>
		)}
	/>
);
